import React, { useContext, useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom'
import { deleteUser } from '../../../action';
import { TabTitle } from '../../../util/titleChanger';
import { api } from '../../../util/urlConfig';
import Loading from '../../../util/Loading'
import { GlobalState } from '../../../GlobalState';

export default function UserDashboard() {
    TabTitle("User Dashboard");
    const state = useContext(GlobalState);
    const [allUsers] = state.userAPI.allUsers;

    //Local States
    const [rowPerPage] = state.userAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.userAPI.pageNumber;
    const [totalPages] = state.userAPI.totalPages;
    const [setSearch] = state.userAPI.search;
    const [callback, setCallback] = state.roleAPI.callback;

    useEffect(() => {
    }, [rowPerPage, allUsers, pageNumber]);

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1
        setPageNumber(newPageNumber);
    }

    const searchHandle = (event) => {
        event.preventDefault();
        setPageNumber(1)
        setSearch(event.target.value ? event.target.value : "")
    }

    const deleteUserHandler = (id) => {
        deleteUser(id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.alert(res.data);
                setCallback(!callback)
            }
        })
    }

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>User Details</p>
                    <div>
                        <input type="text" name="search" id="search" placeholder='Search user here...' onChange={e => searchHandle(e)} />
                        <Link to="/user-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    allUsers.count === 0 ? <div className="loading-page-container"><Loading /></div> :
                        <div>
                            <div className="table_section">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Avatar</th>
                                            <th>User Code</th>
                                            <th>Full Name</th>
                                            <th>NIC</th>
                                            <th>Role</th>
                                            <th>Email</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            allUsers.data ? allUsers.data.map(user => (

                                                <tr key={user.id}>
                                                    <td>
                                                        <img src={user.upload_image ? api + "/" + user.upload_image.image_url : " /img/dummy_avatar.png"} alt="avatar" />
                                                    </td>
                                                    <td> {user.user_code}</td>
                                                    <td>{user.first_name.concat(" ", user.last_name)}</td>
                                                    <td>{user.nic}</td>
                                                    <td>{user.role.name}</td>
                                                    <td>{user.email}</td>
                                                    <td className={user.status.toUpperCase() === "ACTIVE" ? "status-active-text" : "status-pending-text"}><p>{user.status}</p></td>
                                                    <td>
                                                        <Link to={`/user-form/${user.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                        <Link to={`/user-view/${user.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                        <button onClick={() => deleteUserHandler(user.id)}><i className="uil uil-trash-alt"></i></button>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="8">Can not found any users.</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel="next >"
                                onPageChange={pageNumberHandler}
                                marginPagesDisplayed={2}
                                pageCount={totalPages}
                                previousLabel="< previous"
                                renderOnZeroPageCount={null}
                                containerClassName='pagination'
                                pageLinkClassName='page-num'
                                previousLinkClassName='page-num'
                                nextLinkClassName='page-num'
                                activeLinkClassName='active-num'
                            />
                        </div>
                }
            </div>

            <ToastContainer />
        </div>
    )
}
